<!--选项卡，仿el-tabs选项卡，用于表格切换，避免同样内容重复写多次-->
<template>
  <div
    class="line-tabs ly-c-flex"
    :class="{ 'no-line-bottom': shortLine || isCard, 'card-tabs': isCard }"
  >
    <div class="tab-body ly-c-flex">
      <div class="ly-c-flex tab-content">
        <div
          v-for="(item, index) in tabs"
          :key="index"
          class="tabs ly-c-flex column"
          :class="{
            'is-active': actived == item[tabValue],
            'bottom-line': !shortLine && !isCard,
          }"
          @click="tabChange(item, index)"
        >
          <slot name="name" :item="item">
            {{ item.label }}
          </slot>
          <span v-if="shortLine" class="line"></span>
        </div>
      </div>
    </div>

    <!-- 按钮组 -->
    <div class="right-btn">
      <slot name="tabsBtn"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "line-tabs",
  props: {
    tabs: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: [String, Number],
      default: "",
    },
    tabLabel: {
      type: String,
      default: "label",
    },
    tabValue: {
      type: String,
      default: "value",
    },
    shortLine: {
      //下划线是否为短的下划线,目前仅工作台使用
      type: Boolean,
      default: false,
    },
    isCard: {
      //是否为卡片式
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeIndex: 0,
      actived: this.value,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.actived = val;
      },
    },
  },
  created() {
    this.tabChange(this.tabs[0], 0);
  },
  methods: {
    tabChange(item, index) {
      this.activeIndex = index;
      this.actived = item[this.tabValue];
      this.$emit("input", this.actived);
      this.$emit("tab-change", item, index);
    },
  },
};
</script>

<style scoped lang="scss">
.line-tabs {
  width: 100%;
  &.top {
    margin-top: 9px;
  }
  .ly-c-buttons {
    margin: 0;
    padding: 0;
  }
  &:not(.no-line-bottom) {
    // border-bottom: 1px solid #edeff2;
    .tabs {
      margin-right: 10px;
    }
  }

  .tab-body {
    .tabs {
      position: relative;
      padding: 7px 14px;
      box-sizing: border-box;
      line-height: 20px;
      font-size: 14px;
      color: #a1acb8;
      opacity: 0.6;
      font-weight: 400;
      cursor: pointer;

      .line {
        width: 14px !important;
        height: 3px;
        border-radius: 1.5px;
        background-color: $primaryColor;
        opacity: 0;
        margin-top: 3px;
        // padding: 0 50px;
        box-shadow: 0px 4px 6px 0px rgba(132, 134, 150, 0.78);
        // box-shadow: 0px 3px 8px 0px $tab_line_shadow;
      }

      &:hover,
      &.is-active {
        color: $fontColor;
        opacity: 1;
      }

      &.is-active {
        font-weight: 600;
        &.bottom-line {
          border-bottom: 1.6px solid $primaryColor;
        }
        .line {
          opacity: 1;
        }
      }
    }
  }

  .right-btn {
    flex-grow: 1;
    flex: 1;
  }
}
.card-tabs {
  .tab-content {
    background: $tabs_card_bag;
    border-radius: $borderRadius;
    border: 2px solid $tabs_card_bag;
    .tabs {
      color: $search_text;
      padding: 4px 20px;
      &.is-active {
        background: $card_body;
        color: $primaryColor;
        border-radius: 2px;
      }
    }
  }
}
</style>